import { render, staticRenderFns } from "./ShopProfile.vue?vue&type=template&id=e6415132&scoped=true"
import script from "./ShopProfile.vue?vue&type=script&lang=ts"
export * from "./ShopProfile.vue?vue&type=script&lang=ts"
import style0 from "./ShopProfile.vue?vue&type=style&index=0&id=e6415132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6415132",
  null
  
)

export default component.exports